import script from "./TwoFactor.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactor.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactor.vue?vue&type=style&index=0&id=2b0a1ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0a1ffc"]])

export default __exports__